(() => {
  const storageKey = 'bolt-preview-cart-v1';

  const readCart = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(stored) ? [...new Set(stored.filter(id => typeof id === 'string'))] : [];
    } catch {
      return [];
    }
  };

  const writeCart = items => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(items));
    } catch {
      // The in-page cart still works when browser storage is unavailable.
    }
  };

  const savedItems = readCart();
  if (typeof window.addToPreviewCart === 'function') {
    savedItems.forEach(id => window.addToPreviewCart(id));
    if (savedItems.length && typeof window.setCart === 'function') window.setCart(false, false);
  }

  document.addEventListener('click', event => {
    const addButton = event.target.closest('[data-template-buy]');
    if (addButton?.dataset.productId) {
      const items = readCart();
      if (!items.includes(addButton.dataset.productId)) {
        items.push(addButton.dataset.productId);
        writeCart(items);
      }
      return;
    }

    const removeButton = event.target.closest('[data-cart-remove]');
    if (removeButton?.dataset.cartRemove) {
      writeCart(readCart().filter(id => id !== removeButton.dataset.cartRemove));
    }
  }, true);
})();
